<template>
  <div class="collapse-list vch-grid" :class="{ 'row pdp-collapse': productPage }">
       
    <div :class="{ 'vch-col-12 collapse-content': productPage }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
const ENV_ELEMENT_ID = "environmental_impact";
export default {
  name: 'collapse-list',
  props: {
    productPage: { type: Boolean, require: false, default: false },
    accordionNames: { type: String, require: false, default: "" },
    accordionTabNames: { type: Array, default: () => ([]) },
  },
  data() {
    return {
      isDesktop: window.innerWidth ? window.innerWidth > 767 : true,
      isTablet: window.innerWidth ? window.matchMedia('(min-width: 768px) and (max-width: 1024px)').matches : true,
      stickyAsserts: [],
      activeItem: 0,
    };
  },
  mounted() {
    if (!this.productPage && !this.isDesktop) {
      this.$slots.default[0].elm
        .querySelector('.collapse')
        .classList.add('expanded');
    }
    if (this.productPage) {
      window.addEventListener('resize', () => {
        this.isDesktop = window.innerWidth ? window.innerWidth > 767 : true;
      });
      Array.prototype.forEach.call(this.$children, item => {
        let asserts = ''
        if (item.collapseTitle) {
          asserts = {
            title: item.collapseTitle,
            icon: item.collapseIcon
          };
        } else {
          asserts = {
            title: item.collapseSlotsCollection,
            icon: item.collapseIcon
          };
        }
        this.stickyAsserts.push(asserts);
        if (item.$options.name == 'collapse') {
          let tabName = asserts.title.replace(/\s+/g, '_').replace(":", '').toLowerCase();
          this.accordionTabNames.push(tabName);
        }
      });
      if (window.innerWidth > 767) {
        this.$children[0] && (this.$children[0].collapsed = true);
      } else {
        Array.prototype.forEach.call(this.$children, item => {
          item.collapsed = false;
        });
      }
      if (!!window.location.hash && this.accordionTabNames) {
        let fragment = window.location.hash.replace("#", "")
        this.triggerAccordion(fragment, false);
      } else if (document.getElementById(ENV_ELEMENT_ID)) {
        this.triggerAccordion(ENV_ELEMENT_ID, true);
      }
    }
  },
  methods: {
    ...mapMutations('productDetail', [
      'SET_ISPIL_PAGE_DATA',
    ]),
    collapseOpen(index, flag = false) {
      this.activeItem = index;
      Array.prototype.forEach.call(this.$children, item => {
        item.collapsed = false;
        if (item.$options.name === 'sustainability') {
          item.$children[item.$children.length - 1].collapsed = false;
        }
      });
      if (this.$children[index].$options.name === 'sustainability') {
        this.$children[index].$children[
          this.$children[index].$children.length - 1
        ].collapsed = false;
      }

      if (!this.$children[index].collapseTitle) {
        this.$children[index].collapsed = true;
        this.$children[index].triggerGA();
      } else {
        this.$children[index].$children[
          this.$children[index].$children.length - 1
        ].collapsed = true;
        this.$children[index].$children[
          this.$children[index].$children.length - 1
        ].triggerGA();
      }
      let spaceReducer = window.innerWidth > 1024 ? 112 : 65.5;
      let scrollLength = this.$el.parentElement.offsetTop - spaceReducer;
      if (!flag) {
        window.scrollTo({ top: scrollLength, behavior: 'smooth' });
      }
    },
    triggerAccordion(fragment, isFlag = false) {
      let accordionsTab = this.accordionTabNames
      let accordionsProps = this.accordionNames.split(',')
      let accordionIndex, accordionPropIndex = 0;
      let hasSustainability = Array.prototype.some.call(this.$children, item => (item.$options.name === 'sustainability'));
      if (hasSustainability) {
        accordionsTab.push('environmental_impact');
        accordionsProps.push('environmental_impact');
      }
      if (accordionsTab.length || accordionsProps.length) {
        let openIndex = 0
        accordionIndex = accordionsTab.indexOf(fragment)
        if (accordionIndex > -1) {
          openIndex = accordionIndex
        } else {
          accordionPropIndex = accordionsProps.indexOf(fragment);
          if (accordionPropIndex > -1) {
            openIndex = accordionPropIndex
          }
        }
        if (fragment == 'environmental_impact') {
          this.SET_ISPIL_PAGE_DATA(true)
          if (window.eventBus) {
            window.eventBus.$on('navigateToPIL', () => {
              this.collapseOpen(openIndex, false);
            })
          }
        }
        setTimeout(() => {
          this.collapseOpen(openIndex, isFlag);
        }, 250)
      }
    }
  }
};
</script>
<style lang="scss" src="./product-note.scss"></style>
